module.exports = __webpack_public_path__ + "img/logo somente brasao.f85ac95d.png";